module.exports = new __parcel__URL__("retrospective-dark.2133cd8c.png").toString();